import { Button, Modal } from "react-bootstrap";
import { useRecoilState } from "recoil";
import { userInfoAtom } from "src/atoms";
import { update } from "src/service/user";
import { setUserInfoToLocalStorage } from "src/utils/storage/auth";
import { SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { editPasswordValidation } from "components/Common/Modal/MyAccount/yup";
import { Dispatch, SetStateAction, useRef } from "react";
import FormErrorMessage from "../FormErrorMessage";
import "./MyAccount.style.scss";
import { useTranslation } from "react-i18next";
import styles from "src/components/Console/MyAccount/MyAccount.module.scss";
interface EditPasswordInputs {
  password: string;
  newPassword: string;
  newPasswordCheck: string;
}
interface IEditPasswordModalProps {
  showEditPasswordModal: boolean;
  setShowEditPasswordModal: Dispatch<SetStateAction<boolean>>;
}
const EditPasswordModal = ({
  showEditPasswordModal,
  setShowEditPasswordModal,
}: IEditPasswordModalProps) => {
  const { t } = useTranslation();
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const submitButton = useRef<HTMLButtonElement>(null); // form 제출 버튼
  const {
    handleSubmit,
    register,
    reset,
    getValues,
    setValue,
    control,
    formState: { errors },
  } = useForm<EditPasswordInputs>({
    defaultValues: {
      password: "",
      newPassword: "",
      newPasswordCheck: "",
    },
    resolver: yupResolver(editPasswordValidation),
    mode: "all",
  });
  const onSubmit: SubmitHandler<EditPasswordInputs> = async (data) => {
    const { newPassword, newPasswordCheck, password } = data;
    const updUserInfo = {
      userPwd: password,
      newUserPwd: newPassword,
    };

    try {
      const result = await update(updUserInfo);
      if (result) {
        alert(t("navBar.myAccount.popUp.changePassword.checkMsg6"));
      } else {
        alert(t("navBar.myAccount.popUp.commonCheckMsg"));
      }
      setShowEditPasswordModal(false);
    } catch (error: any) {
      if (error?.errorCode && error?.errorMessage) {
        if (error.errorCode === "NO_DATA") {
          alert(t("navBar.myAccount.popUp.changePassword.checkMsg5"));
        } else {
          alert(error.errorMessage);
          setShowEditPasswordModal(false);
        }
      }
    }
  };

  return (
    <Modal
      show={showEditPasswordModal}
      onHide={() => setShowEditPasswordModal(false)}
      className="modal--sm"
      style={{ opacity: 1 }}
      centered
      dialogClassName={styles.modalDialogSm}
    >
      <Modal.Header closeButton>
        <h4 className={styles.modalHeaderTitle}>
          {t("navBar.myAccount.popUp.changePassword.title")}
        </h4>
      </Modal.Header>
      <Modal.Body className={styles.modalBodySm}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <input
            {...register("password")}
            autoComplete="off"
            type="password"
            placeholder={t(
              "navBar.myAccount.popUp.changePassword.enterCurrentPassword"
            )}
            className={`
            form-control ${
              errors.password
                ? "form-textbox-invalid"
                : getValues("password") !== ""
                ? "form-textbox-valid"
                : ""
            } custom-form mg mb-20`}
          />
          {errors.password && (
            <FormErrorMessage
              errorMessage={errors?.password?.message as string}
            />
          )}
          <input
            {...register("newPassword")}
            autoComplete="off"
            type="password"
            placeholder={t(
              "navBar.myAccount.popUp.changePassword.enterNewPassword"
            )}
            className={`
            form-control ${
              errors.newPassword
                ? "form-textbox-invalid"
                : getValues("newPassword") !== ""
                ? "form-textbox-valid"
                : ""
            } custom-form mg mb-20`}
          />
          {errors.newPassword && (
            <FormErrorMessage
              errorMessage={errors?.newPassword?.message as string}
            />
          )}
          <input
            {...register("newPasswordCheck")}
            autoComplete="off"
            type="password"
            placeholder={t(
              "navBar.myAccount.popUp.changePassword.confirmPassword"
            )}
            className={`
            form-control ${
              errors.newPasswordCheck
                ? "form-textbox-invalid"
                : getValues("newPasswordCheck") !== ""
                ? "form-textbox-valid"
                : ""
            } custom-form mg mb-20`}
          />
          {errors.newPasswordCheck && (
            <FormErrorMessage
              errorMessage={errors?.newPasswordCheck?.message as string}
            />
          )}
          <button
            ref={submitButton}
            type="submit"
            style={{ display: "none" }}
          />
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className={`btn btn-gray ${styles.secondaryActionButton}`}
          onClick={() => setShowEditPasswordModal((prev) => !prev)}
        >
          {t("common.cancelBtn")}
        </Button>
        <Button
          type="submit"
          className={`${styles.primaryActionButton}`}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            submitButton.current?.click();
          }}
        >
          {t("common.okBtn")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditPasswordModal;
